import { store } from '../../store-config';

export const getInternationalizationInfo = () => {
  return store.getState().auth.appState.internationalizationInfo;
}

export const getSystemParameters = (parameterName) => {
  return store.getState().auth.appState.systemParameters[parameterName];
}